const gradesEnum = {
    Grade1:  { value: 1,  label: "כל שכבה א'"  },
    Grade2:  { value: 2,  label: "כל שכבה ב'"  },
    Grade3:  { value: 3,  label: "כל שכבה ג'"  },
    Grade4:  { value: 4,  label: "כל שכבה ד'"  },
    Grade5:  { value: 5,  label: "כל שכבה ה'"  },
    Grade6:  { value: 6,  label: "כל שכבה ו'"  },
    Grade7:  { value: 7,  label: "כל שכבה ז'"  },
    Grade8:  { value: 8,  label: "כל שכבה ח'"  },
    Grade9:  { value: 9,  label: "כל שכבה ט'"  },
    Grade10: { value: 10, label: "כל שכבה י'"  },
    Grade11: { value: 11, label: "כל שכבה יא'" },
    Grade12: { value: 12, label: "כל שכבה יב'" },
};

export const gradesList = Object.values(gradesEnum);

export default gradesEnum;
